/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ApiService, AuthStoreService } from '../../../../core/services';
import { ErrorResponseModel } from '../../../../core/models';
import { Injectable } from '@angular/core';
import { ModulesEnum } from '../../../../core/enums';
import { Observable } from 'rxjs';
import { ServicesEnum } from '../enums/api';

@Injectable()
export class ServicesApiService {

    constructor(
        private api: ApiService,
        private authStoreService: AuthStoreService,
    ) {
    }

    /**
     * Send request to restart a service
     */
    public restartService(service: string, options?: any): Observable<any> {
        return new Observable(
            (observer) => {
                // Get our selected module details
                const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

                this.api.put(
                    ServicesEnum.PUT_SERVICE_RESTART(service),
                    null,
                    moduleAuth,
                    true,
                    options
                ).subscribe({
                    next: (response: any): void => {
                        observer.next(response);
                        observer.complete();
                    },
                    error: (error: ErrorResponseModel): void => {
                        observer.error(error);
                        observer.complete();
                    }
                });
            }
        );
    }

    /**
     * Send request to reload a service
     */
    public reloadService(service: string, options?: any): Observable<any> {
        return new Observable(
            (observer) => {
                // Get our selected module details
                const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

                this.api.put(
                    ServicesEnum.PUT_SERVICE_RELOAD(service),
                    null,
                    moduleAuth,
                    true,
                    options
                ).subscribe({
                    next: (response: any): void => {
                        observer.next(response);
                        observer.complete();
                    },
                    error: (error: ErrorResponseModel): void => {
                        observer.error(error);
                        observer.complete();
                    }
                });
            }
        );
    }

    /**
     * Apply all pending restart/reload states
     * @returns {Observable<any>}
     */
    public applyAll(options?: any): Observable<any> {
        return new Observable((observer) => {
                // Get our selected module details
                const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

                this.api.put(
                    ServicesEnum.PUT_SERVICES_APPLY,
                    null,
                    moduleAuth,
                    true,
                    options
                ).subscribe({
                    next: (response: any): void => {
                        observer.next(response);
                        observer.complete();
                    },
                    error: (error: ErrorResponseModel): void => {
                        observer.error(error);
                        observer.complete();
                    }
                });
            }
        );
    }

    /**
     * Get service status.
     * @param options
     */
    public getServiceStatus(options?: any): Observable<any> {
        return new Observable(
            (observer) => {
                // Get our selected module details
                const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

                this.api.get(
                    ServicesEnum.GET_SERVICES_STATUS,
                    moduleAuth,
                    true,
                    options
                ).subscribe({
                    next: (response: any): void => {
                        observer.next(response);
                        observer.complete();
                    },
                    error: (error: ErrorResponseModel): void => {
                        observer.error(error);
                        observer.complete();
                    }
                });
            }
        );
    }
}
